var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© 2019 – "),_c('a',{attrs:{"href":"https://www.bendingspoons.com"}},[_vm._v("Bending Spoons")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }